module.exports = {
    add: {
        branches: 'Přidat pobočku',
        cases: 'Přidat',
        clients: 'Přidat klienta',
        insurers: 'Přidat pojišťovnu',
        intervalSets: 'Přidat rastr',
        persons: 'Přidat osobu',
        users: 'Přidat uživatele',
        vehicles: {
            serviceLog: 'Přidat',
            carIns: 'Přidat',
            accIns: 'Přidat',
            stk: 'Přidat',
            emise: 'Přidat',
        },
        vehicleCategories: 'Přidat ceník',
    },
    confirm: {
        archive: {
            title: {
                branches: 'Smazat pobočku?',
                clients: 'Smazat klienta?',
                insurers: 'Smazat pojišťovnu?',
                intervalSets: 'Smazat rastr?',
                persons: 'Smazat osobu?',
                users: 'Smazat uživatele?',
                vehicleCategories: 'Smazat ceník?',
            },
            message: {
                branches: 'Přejete is opravdu smazat pobočku?',
                clients: 'Přejete is opravdu smazat tohoto klienta?',
                insurers: 'Přejete is opravdu smazat pojišťovnu?',
                intervalSets: 'Přejete is opravdu smazat rastr?',
                persons: 'Přejete is opravdu smazat tuto osobu?',
                users: 'Přejete is opravdu smazat uživatele?',
                vehicleCategories: 'Přejete is opravdu smazat ceník?',
            },
        },
        goToDetail: {
            title: {
                branches: 'Přejít na editaci pobočky?',
                clients: 'Přejít na editaci klienta?',
                contactPersons: 'Přejít na editaci kontaktní osoby?',
                drivers: 'Přejít na editaci řidiče?',
                enums: {
                    tyreMake: 'Přejít na editaci značek?',
                    tyreSize: 'Přejít na editaci rozměrů?',
                },
                intervalSets: 'Přejít na editaci rastru?',
                persons: 'Přejít na editaci osoby?',
                rentals: 'Přejít na editaci zápůjčky?',
                reservations: 'Přejít na editaci rezervace?',
                vehicleCategories: 'Přejít na editaci ceníku?',
                vehicles: 'Přejít na editaci vozidla?',
            },
            message: 'Přechodem budou ztraceny aktuálně provedené úpravy.',
        },
        remove: {
            title: {
                enums: {
                    tyreMake: 'Smazat značku?',
                    tyreSize: 'Smazat rozměr?',
                },
                files: 'Smazat nahraný soubor?',
                photos: 'Smazat fotografii?',
                records: 'Smazat záznam?',
            },
            message: {
                enums: {
                    tyreMake: 'Přejete is opravdu smazat značku?',
                    tyreSize: 'Přejete is opravdu smazat rozměr?',
                },
                files: {
                    clients: 'Opravdu chcete smazat nahraný soubor?<br>Po uložení klienta bude smazání nevratné.',
                    persons: 'Opravdu chcete smazat nahraný soubor?<br>Po uložení osoby bude smazání nevratné.',
                    vehicles: 'Opravdu chcete smazat nahraný soubor?<br>Po uložení vozidla bude smazání nevratné.',
                },
                photos: {
                    cases: 'Opravdu chcete smazat tuto fotografii?<br>Po uložení zápůjčky bude smazání nevratné.',
                    vehicles: 'Opravdu chcete smazat tuto fotografii?<br>Po uložení vozidla bude smazání nevratné.',
                },
                records: {
                    vehicles: 'Opravdu chcete smazat tento záznam?<br>Po uložení vozidla bude smazání nevratné.',
                },
            },
        },
        restore: {
            title: {
                branches: 'Obnovit pobočku?',
                clients: 'Obnovit klienta?',
                insurers: 'Obnovit pojišťovnu?',
                intervalSets: 'Obnovit rastr?',
                persons: 'Obnovit osobu?',
                users: 'Obnovit uživatele?',
                vehicleCategories: 'Obnovit ceník?',
            },
            message: {
                branches: 'Přejete si opravdu obnovit pobočku?',
                clients: 'Přejete si opravdu obnovit tohoto klienta?',
                insurers: 'Přejete si opravdu obnovit pojišťovnu?',
                intervalSets: 'Přejete si opravdu obnovit rastr?',
                persons: 'Přejete si opravdu obnovit tuto osobu?',
                users: 'Přejete si opravdu obnovit uživatele?<br>Uživatel získá opět přístup do systému.',
                vehicleCategories: 'Přejete si opravdu obnovit ceník?',
            },
        },
    },
    enums: {
        tyreMake: {
            title: 'Značky',
            nu: 'Nová značka pneumatik',
        },
        tyreSize: {
            title: 'Rozměry',
            nu: 'Nový rozměr pneumatik',
        },
    },
    fields: {
        common: {
            id: 'ID',
            name: 'Jméno',
            title: 'Titul',
            firstName: 'Jméno',
            lastName: 'Příjmení',
            address: 'Adresa',
            street: 'Ulice',
            city: 'Město',
            zip: 'PSČ',
            ico: 'IČO',
            dic: 'DIČ',
            email: {
                short: 'E-mail',
                long: 'E-mailová adresa',
            },
            phone: {
                short: 'Telefon',
                long: 'Telefonní číslo',
            },
            note: 'Poznámka',
            birthDate: 'Datum narození',
            cisloOp: 'Číslo OP',
            scanOp: 'Nahrát scan OP',
            cisloRp: 'Číslo ŘP',
            platnostRp: 'Platnost ŘP',
            scanRp: 'Nahrát scan ŘP',
            cisloPasu: 'Číslo pasu',
            scanPasu: 'Nahrát scan pasu',
            position: 'Funkce',
            date: 'Datum',
            from: 'Od',
            to: 'Do',
            status: 'Stav',
            rz: 'RZ',
            vin: 'VIN',
            price: {
                default: 'Cena (bez DPH)',
                unit: 'Kč',
            },
            scanProtokolu: {
                default: 'Doklady',
                detail: 'Nahrát doklady',
            },
            scanZeleneKarty: {
                default: 'Doklady',
                detail: 'Nahrát doklady',
            },
            scanSmlouvy: {
                default: 'Doklady',
                detail: 'Nahrát doklady',
            },
        },
        branches: {
            inv: {
                companyName: 'Jméno firmy',
                orZapis: 'Zápis v obchodním rejstříku',
                bank: 'Banka',
                swift: 'SWIFT',
                iban: 'IBAN',
            },
            loc: {
                name: {
                    detail: 'Název',
                    master: 'Název pobočky',
                },
            },
        },
        cases: {
            code: 'Číslo',
            vehicle: {
                default: 'Vozidlo',
                condition: 'Stav vozidla',
            },
            client: 'Klient',
            owner: 'Vlastník',
            guarantor: 'Ručitel',
            typeStatus: 'Typ / status',
            isInternal: 'Interní',
            updated: 'Poslední změna',
            allowAbroad: 'Povolit výjezd za hranice',
            zpusobPlatby: {
                default: 'Způsob platby',
                options: {
                    cash: 'Hotově',
                    transfer: 'Převodem',
                },
            },
            typPujcovneho: {
                default: 'Typ půjčovného',
                options: {
                    daily: 'Denní',
                    monthly: 'Měsíční',
                },
            },
            deposit: {
                default: 'Kauce',
                unit: 'Kč',
            },
            price: {
                default: 'Denní / měsíční sazba',
                daily: 'Denní sazba',
                monthly: 'Měsíční sazba',
                unit: 'Kč',
            },
            kmLimit: {
                default: 'Denní / měsíční limit',
                daily: 'Denní limit',
                monthly: 'Měsíční limit',
                unit: 'km',
            },
            totalKmLimit: {
                default: 'Limit na celou dobu zápůjčky',
                unit: 'km',
            },
            photosOut: 'Fotografie poškození při předání',
            photosIn: 'Fotografie poškození při vrácení',
            contract: {
                generated: {
                    default: 'Smlouva vygenerována',
                    rs: 'Počáteční dodatek vygenerován',
                },
                signed: {
                    default: 'Smlouva podepsána',
                    rs: 'Počáteční dodatek podepsán',
                },
                terminated: 'Datum předčasného ukončení zápůjčky',
            },
            protocolOut:{
                snapshot: {
                    vehicle: {
                        condition: 'Stav vozidla',
                    },
                },
                generated: 'Předávací protokol vygenerován',
                signed: 'Předávací protokol podepsán',
            },
            protocolIn: {
                snapshot: {
                    vehicle: {
                        condition: 'Stav vozidla',
                    },
                },
                generated: 'Protokol o vrácení vozidla vygenerován',
                signed: 'Protokol o vrácení vozidla podepsán',
            },
            from: {
                default: 'Od',
                rental: 'Datum řádného započetí zápůjčky',
            },
            to: {
                default: 'Do',
                rental: 'Datum řádného ukončení zápůjčky',
            },
        },
        claims: {
            externalId: 'RZ',
            client: 'Klient',
            occured: 'Datum a čas nehody',
            created: 'Vytvořena',
            download: ' ',
            state: {
                default: 'Stav',
                detail: 'Odeslána do pojišťovny',
            },
            type: 'Typ',
            carInsNumber: 'Číslo pojistky (povinné ručení)',
            accInsNumber: 'Číslo pojistky (havarijní pojištění)',
            case: {
                client: 'Klient',
            },
            vehicle: 'Vozidlo',
            occuredDate: 'Datum nehody',
            occuredTime: 'Čas nehody',
            location: 'Místo nehody',
            mileage: {
                default: 'Stav tachometru při nehodě',
                unit: 'km',
            },
            damageEstimate: {
                default: 'Přibližná odhadovaná výše škody',
                unit: 'Kč',
            },
            description: 'Popis nehody',
            driver: {
                default: 'Řidič',
                birthDate: 'Datum narození řidiče',
                street: 'Ulice řidiče',
                city: 'Město řidiče',
                zip: 'PSČ řidiče',
            },
            repairShopName: 'Název autorizovaného servisu',
            repairShopPerson: 'Kontaktní osoba ze servisu',
            repairShopEmail: 'E-mail do servisu',
            repairShopPhone: 'Telefon do servisu',
            accidentReport: 'Záznam o dopravní nehodě',
            policeReport: 'Šetřeno policií',
            damagePhotos: 'Rozsah poškození',
            submitted: 'Odeslána klientem',
            resolved: 'Vyřešena',
            resolvedBy: 'Vyřešil(a)',
        },
        clients: {
            companyName: 'Název firmy',
            assist: 'Asistenční služba',
            rsFrom: 'Rámcová smlouva od',
            rsTo: 'Rámcová smlouva do',
            orZapis: 'Zápis v obchodním rejstříku',
        },
        enums: {
            name: 'Parametr',
            values: 'Hodnoty',
        },
        insurers: {
            name: {
                default: 'Jméno',
                master: 'Jméno pojišťovny',
            },
        },
        intervalSets: {
            name: 'Název rastru',
            values: 'Intervaly',
        },
        persons: {
            drivesFor: 'Řidičem',
            isContactFor: 'Kontaktní osobou',
            contact: 'Kontakt',
        },
        users: {
            password: 'Heslo',
            branch: {
                default: 'Pobočka',
                loc: {
                    name: 'Pobočka',
                },
            },
            role: {
                default: 'Úroveň přístupu',
                options: {
                    tech: 'Technik',
                    manager: 'Manažer',
                    admin: 'Administrátor',
                },
            },
            lastLogin: 'Poslední přihlášení',
            signature: 'Nahrát podpis',
        },
        vehicleCategories: {
            name: {
                default: 'Název',
                master: 'Název ceníku',
            },
            intervalSet: {
                default: 'Rastr',
                name: 'Rastr',
            },
            baseDailyPrice: {
                default: 'Denní sazba',
                unit: 'Kč',
            },
            dailyPrices: {
                unit: 'Kč',
                intervals: {
                    unit: 'dní|den|dny|dní',
                },
            },
            monthlyPrice: {
                default: 'Měsíční sazba',
                unit: 'Kč',
            },
            dailyKmLimit: {
                default: 'Denní limit',
                detail: 'Max. kilometrů za den',
                unit: 'km',
            },
            monthlyKmLimit: {
                default: 'Měsíční limit',
                detail: 'Max. kilometrů za měsíc',
                unit: 'km',
            },
            pricePerExtraKm: {
                default: 'Sazba za kilometr nad limit',
                unit: 'Kč',
            },
            serviceDays: {
                default: 'Servisní doba',
                unit: 'dní|den|dny|dní',
            },
            isDefault: {
                default: 'Výchozí',
                detail: 'Nastavit jako výchozí',
            },
        },
        vehicles: {
            name: {
                default: 'Vozidlo',
                detail: 'Značka a typ',
            },
            rzCreated: 'RZ / Přidáno',
            created: 'Přidáno do SR',
            vinOtp: 'VIN / OTP',
            otp: 'Číslo OTP',
            scanOtp: 'Nahrát scan OTP',
            scanTpv: 'Nahrát scan TPV',
            odometer: {
                default: 'Stav tachometru',
                master: 'Tachometr',
                unit: 'km',
            },
            color: 'Barva',
            protocol: ' ',
            reservationCount: 'Rezervace',
            rentalCount: 'Zápůjčky',
            since: 'Uvedeno do provozu',
            branch: 'Dostupnost na pobočce',
            allBranches: 'Možnost převozu',
            gear: {
                default: 'Převodovka',
                options: {
                    manual: 'Manuální',
                    auto: 'Automatická',
                },
            },
            engineNumber: 'Číslo motoru',
            bodyType: 'Typ karoserie',
            variant: 'Provedení',
            fuelType: {
                default: 'Typ paliva',
                options: {
                    gas: {
                        default: 'Benzín',
                        unit: 'l',
                    },
                    diesel: {
                        default: 'Nafta',
                        unit: 'l',
                    },
                    cng: {
                        default: 'CNG',
                        unit: 'kg',
                    },
                    electric: {
                        default: 'Elektřina',
                        unit: 'kW',
                    },
                    cngAndGas: {
                        default: 'CNG + benzín',
                        unit: 'kg',
                        unit2: 'l',
                    },
                },
            },
            fuelAmount: {
                default: 'Množství paliva',
                cngAndGas: 'Množství CNG',
            },
            fuelAmount2: {
                default: 'Množství paliva',
                cngAndGas: 'Množství benzínu',
            },
            dalnicniZnamka: 'Dálniční známka',
            cngKarta: 'CNG karta',
            povinnaVybava: 'Povinná výbava',
            pocetKlicu: 'Počet klíčů',
            zvedak: 'Zvedák + nářadí',
            navodKObsluze: 'Návod k obsluze',
            kartaRadiciPaky: 'Karta řadicí páky',
            doklady: 'OTP + zelená karta',
            tyreMake: 'Značka',
            tyreSize: 'Rozměr',
            tyreType: {
                default: 'Typ',
                options: {
                    winter: 'Zimní',
                    summer: 'Letní',
                    universal: 'Univerzální',
                },
            },
            tyreDepth: {
                default: 'Hloubka vzorku',
                unit: 'mm',
            },
            spareMake: 'Značka',
            spareSize: 'Rozměr',
            spareType: {
                default: 'Druh',
                options: {
                    fullSize: 'Plnohodnotná',
                    temporary: 'Dojezdová',
                    sealantKit: 'Lepicí sada',
                },
            },
            spareDepth: {
                default: 'Hloubka vzorku',
                unit: 'mm',
            },
            serviceBook: {
                default: 'Servisní knížka',
                options: {
                    electronic: 'Elektronická',
                    paper: 'Klasická',
                    none: 'Chybí',
                },
            },
            condition: 'Stav vozidla',
            isInService: 'Aktuálně v servisu',
            serviceLog: {
                default: 'Servisní zásahy',
                date: 'Datum zásahu',
                description: 'Popis zásahu',
                dateDescription: 'Datum/popis',
            },
            carIns: {
                default: 'Povinné ručení',
                insurer: 'Pojišťovna',
                insurerFromTo: 'Pojišťovna/od-do',
                number: 'Číslo pojistky',
            },
            accIns: {
                default: 'Havarijní pojištění',
                insurer: 'Pojišťovna',
                insurerFromTo: 'Pojišťovna/od-do',
                priceCoPay: 'Cena/spol./min.',
                coPayPercentage: {
                    default: 'Spoluúčast',
                    unit: '%',
                },
                minCoPay: {
                    default: 'Minimální spoluúčast (bez DPH)',
                    unit: 'Kč',
                },
                number: 'Číslo pojistky',
            },
            stk: {
                default: 'Technická kontrola',
                toFrom: 'Platná do/od',
            },
            emise: {
                default: 'Kontrola emisí',
                toFrom: 'Platná do/od',
            },
            purchasePrice: {
                default: 'Nákupní cena',
                unit: 'Kč',
            },
            scanFaktury: 'Scany dokladů',
            deposit:  {
                default: 'Kauce',
                unit: 'Kč',
            },
            category: 'Ceník',
            photos: 'Nahrát fotografie',
        },
    },
    nu: {
        branches: 'Nová pobočka',
        cases: {
            default: 'Nová rezervace / zápůjčka',
            internal: 'Nová interní rezervace',
        },
        clients: {
            fo: 'Nový klient - fyzická osoba',
            po: 'Nový klient - právnická osoba',
        },
        insurers: 'Nová pojišťovna',
        intervalSets: 'Nový rastr',
        persons: 'Nový řidič / kontaktní osoba',
        users: 'Nový uživatel',
        vehicles: {
            default: 'Nové vozidlo',
            serviceLog: 'Nový zásah',
            carIns: 'Nový záznam',
            accIns: 'Nový záznam',
            stk: 'Nový záznam',
            emise: 'Nový záznam',
        },
        vehicleCategories: 'Nový ceník',
    },
    pages: {
        dashboard: 'Dashboard',
        cases: 'Rezervace a zápůjčky',
        ceniky: 'Ceníky',
        klienti: 'Klienti',
        login: 'Přihlášení',
        mujUcet: 'Můj účet',
        nastaveni: 'Obecné nastavení',
        osoby: 'Osoby',
        pneumatiky: 'Pneumatiky',
        pobocky: 'Pobočky',
        pojistneUdalosti: 'Pojistné události',
        pojistovny: 'Pojišťovny',
        rastry: 'Rastry',
        udalosti: 'Události',
        uzivatele: 'Uživatelé',
        vozidla: 'Vozidla',
        podpis: 'Podpis',

        eventsTest: 'Events Test',
        alertLog: 'Alert Log',
    },
    settings: {
        injectIdColumn: 'Zobrazovat v tabulkách ID',
        createPastCases: 'Povolit vytváření caseů v minulosti',
        allowDestroy: 'Povolit trvalé mazání',
        restoreViaMaster: 'Zobrazovat v tabulkách tlačítko obnovení',
        caseNotificationEmails: 'Čárkou oddělené e-mailové adresy pro odesílání interních notifikací o zápůjčkách',
        claimNotificationEmails: 'Čárkou oddělené e-mailové adresy pro odesílání interních notifikací o pojistných událostech',
        terms: 'Nahrát všeobecné obchodní podmínky',
        hideAlerts: 'Skrýt události na dashboardu',
        alertsFetchPeriodSecs: 'Interval automatického načítání událostí na dashboardu (v sekundách, 0 znamená načtení pouze jednou)',
    },
    terms: {
        contract: {
            1: 'smlouva',
            2: 'smlouvy',
            4: 'smlouvu',
        },
        initialAmendment: {
            1: 'počáteční dodatek',
            2: 'počátečního dodatku',
            4: 'počáteční dodatek',
        },
        amendment: {
            1: 'dodatek',
            2: 'dodatku',
            4: 'dodatek',
        },
        protocolOut: {
            1: {
                default: 'předávací protokol',
                short: 'protokol',
            },
            2: {
                default: 'předávacího protokolu',
                short: 'protokolu',
            },
            4: {
                default: 'předávací protokol',
                short: 'protokol',
            },
        },
        protocolIn: {
            1: {
                default: 'protokol o vrácení vozidla',
                short: 'protokol',
            },
            2: {
                default: 'protokolu o vrácení vozidla',
                short: 'protokolu',
            },
            4: {
                default: 'protokol o vrácení vozidla',
                short: 'protokol',
            },
        },
    },
    yes: 'Ano',
    no: 'Ne',
    days: 'dní|den|dny|dní',
};
